import { render, staticRenderFns } from "./RecipientsGraph.vue?vue&type=template&id=e0dbd408&"
import script from "./RecipientsGraph.vue?vue&type=script&lang=js&"
export * from "./RecipientsGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports